// State
export const state = {
  IS_LOADING: 'isLoading',
  DATASETS: 'datasets',
};

// Getters
export const getters = {};

// Mutations
export const mutations = {
  SET_LOADING: 'setLoading',
  SET_DATASETS: 'setDatasets',
};

// Actions
export const actions = {
  ADD_DATASET_TO_PROFILE: 'addDatasetToProfile',
};
